import mixpanel from "mixpanel-browser";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { REDUCER_TYPES } from "store";

const MixpanelComponent = () => {
  const { isLoggedIn, user } = useSelector(
    (state) => state[REDUCER_TYPES.AUTH]
  );

  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
  
  useEffect(() => {
    if (isLoggedIn) mixpanel.identify(user?.id);
  }, [isLoggedIn]);
};

export default MixpanelComponent;
